<script>
export default {
  data() {
    return {
      pagination: {
        total: 0,
        current: 0,
        perPage: 0
      }
    };
  },
  methods: {
    updatePagination(data) {
      this.pagination = {
        total: data.total,
        current: data.current_page,
        perPage: data.per_page
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/mixins/HasPagination.vue